
export default {
    props: ["desc", "img", "linkTo", "isMega"]
}
